<template>
<div class="content-body tenant-settings">
    <div class="">
        <el-form :inline="true" :model="dataForm" @keyup.enter.native="getDataList()" size="small">
            <el-form-item label="订单编码:">
                <el-input size="small" v-model="dataForm.orderCode" placeholder="订单编码" clearable @blur="getDataList"></el-input>
            </el-form-item>
            <el-form-item label="项目名称:">
                <el-input size="small" v-model="dataForm.projectName" placeholder="项目名称" clearable @blur="getDataList"></el-input>
            </el-form-item>
            <el-form-item label="配件单位:">
                <el-input size="small" v-model="dataForm.supportingPartner" placeholder="配件单位" clearable @blur="getDataList"></el-input>
            </el-form-item>
            <el-form-item label="订单状态:">
                <el-select size="small" v-model="dataForm.orderStatus" placeholder="请选择状态" clearable @change="getDataList">
                    <el-option v-for="item in ORDER_STATUS" :key="item.value" :label="item.label" :value="item.value"></el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="订单类型:">
                <el-select size="small" v-model="dataForm.orderType" placeholder="请选择类型" clearable @change="getDataList">
                    <el-option v-for="item in ORDER_TYPE" :key="item.value" :label="item.label" :value="item.value"></el-option>
                </el-select>
            </el-form-item>
            <el-form-item class="fr">
                <el-button size="small" @click="getDataList()" icon="el-icon-search">
                    查询
                </el-button>
                <el-button size="small" v-if="isAuth('sourcing:order:newbutton')" type="primary" @click="addOrUpdateHandle()" icon="el-icon-plus">
                    新建订单
                </el-button>
                <!--                    <el-button size="small" v-if="isAuth('sys:org:savebutton')" type="primary" @click="addOrUpdateHandle()" icon="el-icon-plus">-->
                <!--                        提交审批-->
                <!--                    </el-button>-->
                <el-button size="small" v-if="isAuth('sys:org:savebutton')" type="primary" @click="addOrUpdateHandle()" icon="el-icon-plus">
                    发布
                </el-button>
                <el-button size="small" v-if="isAuth('sys:org:savebutton')" type="primary" @click="addOrUpdateHandle()" icon="el-icon-plus">
                    拉取
                </el-button>
            </el-form-item>
        </el-form>
        <div v-loading="dataListLoading">
            <el-table :data="dataList" row-key="id" size="mini" border style="width: 100%" :default-expand-all="false" :height="tableHeight" :header-cell-style="{ background: '#f5f5f5' }">
                <el-table-column type="index" width="50" label="序号">
                    <template slot-scope="scope">
                        {{ scope.$index + 1 + (pageIndex - 1) * pageSize }}
                    </template>
                </el-table-column>
                <el-table-column prop="orderCode" header-align="center" align="left" label="订单编码" width="170">
                </el-table-column>
                <el-table-column prop="orderType" header-align="center" align="center" label="订单类型" width="170">
                    <template slot-scope="scope">
                        <span>{{ orderTypeFormat(scope.row.orderType) }}</span>
                    </template>
                </el-table-column>
                <el-table-column prop="orderStatus" header-align="center" align="center" label="订单状态" width="140">
                    <template slot-scope="scope">
                        <span>{{ orderStatusFormat(scope.row.orderStatus) }}</span>
                    </template>
                </el-table-column>
                <el-table-column prop="projectName" header-align="center" align="left" label="项目名称" width="170">
                </el-table-column>
                <el-table-column prop="supportingPartner" header-align="center" align="left" label="配件单位" width="170">
                </el-table-column>
                <el-table-column prop="purchaseContacterName" header-align="center" align="left" label="采购联系人" width="170">
                </el-table-column>
                <el-table-column prop="purchaseContacterTel" header-align="center" align="right" label="采购联系人电话" width="150">
                </el-table-column>
                <el-table-column prop="purchaseContacterMail" header-align="center" align="right" label="采购联系人邮箱" width="190">
                </el-table-column>
                <el-table-column prop="recieveContacterName" header-align="center" align="left" label="收件人" width="150">
                </el-table-column>
                <el-table-column prop="recieveContacterTel" header-align="center" align="right" label="收件人电话" width="150">
                </el-table-column>
                <el-table-column prop="recieveAddress" header-align="center" align="left" label="收货地址" width="200">
                </el-table-column>
                <el-table-column prop="unQuoteReason" header-align="center" align="right" label="驳回原因" width="200">
                </el-table-column>
                <el-table-column prop="pic" header-align="center" align="center" width="120" label="当前流程图示">
                    <template slot-scope="scope">
                        <el-link type="primary" style="font-size: 12px;" @click="viewDiagram(scope.row.workflowId)"><i class="el-icon-view" style="margin-right: 5px;"></i>查看</el-link>
                    </template>
                </el-table-column>
                <el-table-column prop="createBy" header-align="center" align="center" label="审批历史" width="120">
                    <template slot-scope="scope">
                        <el-button @click="doHistory(scope.row)">查看</el-button>
                    </template>
                </el-table-column>
                <el-table-column header-align="center" align="left" label="操作" width="190" fixed="right">
                    <template slot-scope="scope">
                        <el-button type="text" size="small" @click="addOrUpdateHandle(scope.row.id)" icon="el-icon-view">
                            查看
                        </el-button>
                        <el-button type="text" size="small" @click="addOrUpdateHandle(scope.row.id)" icon="el-icon-edit">
                            修改
                        </el-button>
                        <el-button type="text" size="small" @click="deleteHandle(scope.row.id)" icon="el-icon-delete" class="button-danger">
                            删除
                        </el-button>
                    </template>
                </el-table-column>
            </el-table>
            <!-- 分页 -->
            <el-pagination @size-change="sizeChangeHandle" @current-change="currentChangeHandle" :current-page="pageIndex" :page-sizes="[10, 20, 50]" :page-size="pageSize" :total="totalPage" layout="total, sizes, prev, pager, next, jumper">
            </el-pagination>
        </div>
        <!-- 弹窗, 新增 / 修改 -->
        <add-or-update v-if="addOrUpdateVisible" ref="addOrUpdate" @refreshDataList="getDataList"></add-or-update>

        <el-drawer title="审批履历" :visible.sync="drawer" :with-header="true">
            <div v-for="str in historyList" :key="str">
                <el-descriptions :title="str.executeTime">
                    <el-descriptions-item label="审批类型">{{str.taskName}}</el-descriptions-item>
                    <el-descriptions-item label="审批结果">{{str.executeName}}</el-descriptions-item>
                </el-descriptions>
                <el-divider></el-divider>
            </div>
        </el-drawer>

        <el-dialog :visible.sync="showViewer" width="80%" title="流程图">
            <el-image :src="diagramUrl" style="margin-bottom: 120px;">
            </el-image>
        </el-dialog>
    </div>
</div>
</template>

<script>
import {
    getLabelByValue,
    ORDER_STATUS,
    getOrderTypeByValue,
    ORDER_TYPE,
} from "@/utils/const";
import {
    fetchOrderList,
    deleteOrder
} from "@/controller/order";
import AddOrUpdate from "./order-add-or-update";
import {
    listAllStatus,
    getProcessDiagramCurrent,
    listCommentHistory
} from '@/controller/workflow'
// require('@/mock/mockOrder');
export default {
    data() {
        return {
            documentClientHeight: document.documentElement["clientHeight"] - 250,
            dataForm: {
                orderCode: '',
                projectName: '',
                supportingPartner: '',
                orderStatus: '',
                orderType: '',
            },
            ORDER_STATUS: ORDER_STATUS,
            getLabelByValue: getLabelByValue,
            ORDER_TYPE: ORDER_TYPE,
            getOrderTypeByValue: getOrderTypeByValue,
            dataList: [],
            tenantList: [],
            pageIndex: 1,
            pageSize: 10,
            totalPage: 0,
            dataListLoading: false,
            dataListSelections: [],
            addOrUpdateVisible: false,
            // 审批历史
            drawer: false,
            // 审批列表
            historyList: [],
            showViewer: false,
            diagramUrl: '',
        };
    },
    components: {
        AddOrUpdate,
    },
    computed: {
        tableHeight: {
            get() {
                return this.$store.state.common.documentClientHeight - 270;
            },
        },
    },
    activated() {
        this.getDataList();
    },
    methods: {
        // 新增或编辑子节点
        // addChildHandle(id, parentId, parentName, parentNodePath) {

        //     console.log(id, parentId, parentName, parentNodePath)
        //     this.addOrUpdateVisible = true
        //     this.$nextTick(() => {
        //         this.$refs.addOrUpdate.init(null, parentId, parentName, parentNodePath)
        //     })
        // },
        // 订单状态
        orderStatusFormat: function (value) {
            if (!value) {
                return "";
            }
            return getLabelByValue(ORDER_STATUS, value);
        },
        // 订单类型
        orderTypeFormat: function (value) {
            // debugger;
            if (!value) {
                return "";
            }
            return getLabelByValue(ORDER_TYPE, value);
        },
        // 获取数据列表
        getDataList() {
            this.dataListLoading = true;
            fetchOrderList({
                    pageNo: this.pageIndex,
                    pageSize: this.pageSize,
                    'orderCode': this.dataForm.orderCode,
                    'projectName': this.dataForm.projectName,
                    'supportingPartner': this.dataForm.supportingPartner,
                    'orderStatus': this.dataForm.orderStatus,
                    'orderType': this.dataForm.orderType,
                    'source': 'SRM'
                })
                .then((data) => {
                    console.log(data, "data");
                    if (data && data.code === "00") {
                        this.dataList = data.body.records;
                        this.totalPage = data.body.total;
                    } else {
                        this.dataList = [];
                        this.totalPage = 0;
                    }
                })
                .catch((e) => {
                    console.log(e);
                })
                .finally(() => {
                    this.dataListLoading = false;
                });
        },
        // 每页数
        sizeChangeHandle(val) {
            this.pageSize = val;
            this.pageIndex = 1;
            this.getDataList();
        },
        // 当前页
        currentChangeHandle(val) {
            this.pageIndex = val;
            this.getDataList();
        },
        // 多选
        selectionChangeHandle(val) {
            this.dataListSelections = val;
        },
        // 新增 / 修改
        addOrUpdateHandle(id) {
            this.addOrUpdateVisible = true;
            this.$nextTick(() => {
                this.$refs.addOrUpdate.init(id);
            });
        },
        // 删除
        deleteHandle(id) {
            console.log(id);
            let ids = id ?
                [id] :
                this.dataListSelections.map((item) => {
                    return item.id;
                });

            this.$confirm(`确定进行删除操作?`, "提示", {
                    confirmButtonText: "确定",
                    cancelButtonText: "取消",
                    type: "warning",
                })
                .then(() => {
                    deleteOrder(ids)
                        .then((data) => {
                            // deleteTech([id]).then((data) => {
                            if (data && data.code === "00") {
                                this.$message({
                                    message: "操作成功",
                                    type: "success",
                                    duration: 1500,
                                    onClose: () => {
                                        this.getDataList();
                                    },
                                });
                            } else {
                                this.$message.error(data.msg);
                            }
                        })
                        .catch((error) => {
                            console.log(error);
                        });
                })
                .catch(() => {});
        },
        // 审批历史
        doHistory(row) {
            this.historyList = []
            listCommentHistory({
                'workflowId': row.workflowId
            }).then(data => {
                if (data && data.code === '00') {
                    this.historyList = data.body
                } else {
                    this.$message.error(data.msg)
                }
            })
            this.drawer = true

        },
        viewDiagram(id) {
            getProcessDiagramCurrent({
                id: id
            }).then(data => {
                this.diagramUrl = data.body
                this.showViewer = true
            })
        },
    },
};
</script>

<style lang="scss" scoped>
.button-danger {
    color: #f56c6c;
}

.text-danger {
    color: #f56c6c;
}

.text-success {
    color: #67c23a;
}

.text-waming {
    color: #e6a23c;
}

.text-info {
    color: #909399;
}

.fr {
    float: right;
}
</style>
